export const SESSION_EXPIRED_PATH = '/login?reason=session-expired';

const INVALID_TOKEN_ERROR = 'Forbidden: Invalid token';
const PUBLIC_AUTH_PATHS = ['/auth/login', '/password-reset/request', '/password-reset/confirm'];

export function isSessionAuthFailure(error) {
  const status = error?.response?.status;
  const requestPath = error?.config?.url || '';

  if (PUBLIC_AUTH_PATHS.some((path) => requestPath.endsWith(path))) {
    return false;
  }

  if (status === 401) {
    return true;
  }

  return status === 403 && error?.response?.data?.error === INVALID_TOKEN_ERROR;
}

export function handleSessionExpiry(
  error,
  {
    appVariant = process.env.REACT_APP_APP_VARIANT || 'staff',
    storage = window.localStorage,
    dispatchAuthChanged = () => window.dispatchEvent(new Event('auth-changed')),
    redirect = (path) => window.location.replace(path),
  } = {}
) {
  if (appVariant === 'customer' || !storage.getItem('token') || !isSessionAuthFailure(error)) {
    return false;
  }

  storage.removeItem('token');
  storage.removeItem('user');
  dispatchAuthChanged();
  redirect(SESSION_EXPIRED_PATH);
  return true;
}
